export const MAX_AREA_ERROR_RATE_PERCENT = 5;
export const AREA_DEVIATION_BLOCK_TEMPLATE = '地块面积与投保面积误差率为 {rate}%，超过允许范围 ±{limit}%，不允许投保';
